import React from "react";
import html2pdf from "html2pdf.js";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";

import moment from "moment";
import { toWords } from "number-to-words";

import { useLocation, useNavigate } from "react-router-dom";

const OverAllReportDownload = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    getValues,
    reset,
  } = useForm();
  const { state } = useLocation();
  console.log("state", state);

  // If caller passed selected row ids (from ViewOrder via PopupModel), prefer those.
  const incomingFiltered = state?.filteredDetails || [];
  const selectedRows = state?.selectedRows || [];
  const detailsToRender =
    Array.isArray(selectedRows) && selectedRows.length > 0
      ? incomingFiltered.filter((d) => selectedRows.includes(d?.id))
      : incomingFiltered;

  const selectFormat = watch("selectFormat");

  const isA5 = selectFormat == "a5";

  console.log("STATE", selectFormat);

  const details = localStorage.getItem("companyDetails");
  const companyDetails = details ? JSON.parse(details) : null;

  console.log("STATE", state);
  let totalAmount = 0;
  let quantity = 0;
  let totalItems = 0;
  let totalPrice = 0;
  let totalwithoutAmount = 0;

  const amount = state?.orderProducts?.reduce((total, item) => {
    const qty = Number(item?.quantity || 0);
    const price = Number(item?.unitPrice || 0);
    return total + qty * price;
  }, 0);

  const discount = Number(state?.discountPrice || 0);
  const gstRate = Number(state?.gstPercentage || 0);

  const totalDiscountedAmount = Number(amount) - Number(discount);
  const totalDiscountedAmountWithoutGst = Number(amount) - Number(discount);

  const gstAmount = (Number(totalDiscountedAmount) * Number(gstRate)) / 100;

  const getWrapperStyle = () => {
    if (selectFormat == "a5") {
      return {
        width: "794px",
        // minHeight: "595px",
        background: "white",
        margin: "10px auto",
        padding: "7px",
        boxSizing: "border-box",
      };
    } else if (selectFormat == "a4") {
      return {
        width: "794px",
        // minHeight: "1123px",
        background: "white",
        margin: "10px auto",
        padding: "7px",
        boxSizing: "border-box",
      };
    }
  };

  // DOWNLOAD START
  const handleDownload = () => {
    const wrappers = document.querySelectorAll("#wrapper_class");

    // Create a temporary container to combine all wrapper content
    const container = document.createElement("div");

    wrappers.forEach((wrapper, index) => {
      const clone = wrapper.cloneNode(true);

      // Optional: Add a page break after each wrapper except the last
      if (index !== wrappers.length - 1) {
        const pageBreak = document.createElement("div");
        pageBreak.style.pageBreakAfter = "always";
        clone.appendChild(pageBreak);
      }

      container.appendChild(clone);
    });

    const opt = {
      margin: 0,
      filename: "overall-invoices.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: {
        unit: "mm",
        format: isA5 ? "a5" : "a4",
        orientation: isA5 ? "landscape" : "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    html2pdf().set(opt).from(container).save();
  };
  // DOWNLOAD END

  const overallBalance =
    detailsToRender?.reduce((acc, curr) => {
      const paymentSum = curr?.payments?.reduce((sum, p) => {
        return sum + Number(p?.balanceAmount || 0);
      }, 0);
      return acc + paymentSum;
    }, 0) || 0;

  // console.log("Total Balance Amount:", overallBalance);

  return (
    <>
      <section className="invoice_main_section">
        {detailsToRender &&
          detailsToRender?.map((data, index) => {
            let nontaxamount = 0;
            let totalnewbalance = 0;

            let igstnetAmount = 0;
            let sumOfNetAmt = 0;
            let taxGroups = {};
            const receivedbalance = Number(
              data?.payments?.[data?.payments?.length - 1]?.receivedAmount || 0
            );
            const pendingbalance = Number(
              data?.payments?.[data?.payments?.length - 1]?.balanceAmount || 0
            );
            return (
              <>
                <div
                  id="wrapper_class"
                  // style={{
                  //   width: "790px",
                  //   background: "white",
                  //   margin: "10px auto",
                  //   padding: "7px",
                  //   boxSizing: "border-box",
                  // }}
                  style={getWrapperStyle()}
                  key={index}
                >
                  <main className="my-2  p-0">
                    <div className="container-fluid">
                      <div className="row">
                        <div
                          className="col-12 col-lg-4 p-1"
                          style={{ border: "1px solid black" }}
                        >
                          <div className="company-name">
                            {companyDetails?.shopName || ""}
                          </div>
                          <p className="invoice_address_part my-0">
                            {`${companyDetails?.companyAddress || ""} , ${
                              companyDetails?.companyLocation || ""
                            } ,${companyDetails?.district || ""} ,PIN-${
                              companyDetails?.companyPincode || ""
                            } `}{" "}
                            <br />
                            Tamilnadu &nbsp;&nbsp; Phone No :{" "}
                            {companyDetails?.customerPhno || ""}
                          </p>
                          <table>
                            <tbody>
                              <tr>
                                <td className="invoice_sub_title">GSTIN</td>
                                <td className="invoice_address_part">
                                  {" "}
                                  <b> : </b> {companyDetails?.gstNumber || ""}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="col-12 col-lg-4 p-2"
                          style={{ border: "1px solid black" }}
                        >
                          <table>
                            <tr>
                              <td colSpan="2">
                                <p className="invoice_cus_address">
                                  <b>{data?.customerName || ""}</b>
                                </p>
                                <p className="invoice_address_part">
                                  {` ${data?.customerAddress || ""},   ${
                                    data?.pincode
                                  }, ${data?.state}`}
                                </p>
                              </td>
                            </tr>
                            <tr>
                              {/* <td className="invoice_sub_title">CONTACT</td> */}
                              <td colSpan="2">
                                <p className="invoice_address_part">
                                  {" "}
                                  {data?.contact || ""}
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td className="invoice_address_part">GSTIN</td>
                              <td>
                                <p className="invoice_address_part">
                                  : {data?.gstNumber}
                                </p>
                              </td>
                            </tr>
                          </table>
                        </div>
                        <div
                          className="col-12 col-lg-4 p-2"
                          style={{ border: "1px solid black" }}
                        >
                          <h6 className="company-name">TAX INVOICE</h6>
                          <table>
                            <tbody>
                              <tr>
                                <td className="invoice_sub_title">
                                  Invoice No
                                </td>
                                <td className="invoice_sub_title">
                                  {" "}
                                  : {data?.invoiceNo || ""}
                                </td>
                              </tr>
                              <tr>
                                <td className="invoice_sub_title">Date</td>
                                <td className="invoice_sub_title">
                                  {" "}
                                  :{" "}
                                  {data?.salesDate
                                    ? moment(data?.salesDate).format(
                                        "DD-MM-YYYY"
                                      )
                                    : ""}
                                </td>
                              </tr>
                              <tr>
                                <td className="invoice_sub_title">Mode</td>
                                <td className="invoice_sub_title">
                                  {" "}
                                  : {data?.transactionMode || ""}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <table className="overall_table">
                      <thead>
                        <tr>
                          <th className="overall_table_heading">SNO</th>
                          <th className="overall_table_heading">
                            Goods Description
                          </th>
                          <th className="overall_table_heading">HSN Code</th>
                          <th className="overall_table_heading">MRP</th>
                          <th className="overall_table_heading">Qty</th>

                          <th className="overall_table_heading">
                            Rate
                            <br />
                            (Before Tax)
                          </th>
                          <th className="overall_table_heading" colSpan="2">
                            IGST
                          </th>
                          <th className="overall_table_heading" colSpan="2">
                            CGST
                          </th>
                          <th className="overall_table_heading" colSpan="2">
                            SGST
                          </th>
                          <th className="overall_table_heading">Net Rate</th>
                          <th className="overall_table_heading">Net Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data &&
                          data?.orderProducts?.map((item, i) => {
                            const unitPrice = Number(item?.unitPrice || 0);
                            const qty = Number(item?.quantity || 0);
                            const gstPercent = Number(item?.gstPercentage || 0);

                            const sgstandcgst = gstPercent / 2;
                            console.log("gst", sgstandcgst);

                            const gstAmount = (unitPrice * gstPercent) / 100;
                            const netRate = unitPrice + gstAmount;
                            const netAmount = netRate * qty;

                            const gstAmountForAll = +(
                              (gstAmount * qty) /
                              2
                            ).toFixed(2); // CGST or SGST
                            const igstAmountForAll = +(gstAmount * qty).toFixed(
                              2
                            ); // Total GST for IGST

                            const isTamilNadu =
                              data?.state?.toLowerCase().replace(/\s+/g, "") ===
                              "tamilnadu";

                            // Accumulate totals
                            sumOfNetAmt += netAmount;

                            if (gstPercent === 0) {
                              nontaxamount += netAmount;
                            } else {
                              taxGroups[gstPercent] =
                                (taxGroups[gstPercent] || 0) + igstAmountForAll;
                            }

                            totalAmount += netAmount;
                            quantity += qty;
                            totalItems += 1;
                            totalnewbalance =
                              Number(overallBalance || 0) +
                              Math.round(sumOfNetAmt);

                            return (
                              <>
                                <tr key={i}>
                                  <td className="invoice_table_product_data">
                                    {i + 1}
                                  </td>
                                  <td className="invoice_table_product_data">
                                    {item?.product?.toUpperCase() || "-"}
                                  </td>
                                  <td className="invoice_table_product_data">
                                    {item?.hsnCode || "-"}
                                  </td>
                                  <td className="invoice_table_product_data">
                                    {item?.mrpPrice || "-"}
                                  </td>
                                  <td className="invoice_table_product_data">
                                    {item?.quantity || "-"}
                                  </td>
                                  <td className="invoice_table_product_data">
                                    {item?.unitPrice || "-"}
                                  </td>

                                  {/* IGST % */}
                                  <td className="invoice_table_product_data">
                                    {isTamilNadu ? "0.00" : gstPercent}
                                  </td>
                                  {/* IGST Amount */}
                                  <td className="invoice_table_product_data">
                                    {isTamilNadu
                                      ? "0.00"
                                      : igstAmountForAll.toFixed(2)}
                                  </td>

                                  {/* CGST % */}
                                  <td className="invoice_table_product_data">
                                    {isTamilNadu ? sgstandcgst : "0.00"}
                                  </td>
                                  {/* CGST Amount */}
                                  <td className="invoice_table_product_data">
                                    {isTamilNadu
                                      ? gstAmountForAll.toFixed(2)
                                      : "0.00"}
                                  </td>

                                  {/* SGST % */}
                                  <td className="invoice_table_product_data">
                                    {isTamilNadu ? sgstandcgst : "0.00"}
                                  </td>
                                  {/* SGST Amount */}
                                  <td className="invoice_table_product_data">
                                    {isTamilNadu
                                      ? gstAmountForAll.toFixed(2)
                                      : "0.00"}
                                  </td>

                                  {/* Net Rate */}
                                  <td className="invoice_table_product_data">
                                    {netRate.toFixed(2)}
                                  </td>

                                  {/* Net Amount */}
                                  <td className="invoice_table_product_data">
                                    {netAmount.toFixed(2)}
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        <tr>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data">
                            {" "}
                            <br />
                            SUB TOTAL
                            <br />
                            ROUNDED-OFF
                          </td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td
                            className="invoice_table_product_data"
                            style={{ borderTop: "1px solid black" }}
                          >
                            {Math.round(sumOfNetAmt).toLocaleString("en-IN")}
                          </td>
                        </tr>
                        <tr>
                          <td className="invoice_table_product_data"></td>
                          <td
                            className="invoice_table_product_data"
                            style={{ border: "1px solid black" }}
                          >
                            <p className="overall_report_bill justify-content-end">
                              <b>TXBLAMT</b>
                            </p>
                            <p className="overall_report_bill">
                              <span>SALES NT</span>
                              <span>
                                {Number(nontaxamount || 0).toFixed(2) || 0}
                              </span>
                            </p>

                            {Object.entries(taxGroups).map(
                              ([gstRate, amount], idx) => (
                                <p className="overall_report_bill" key={idx}>
                                  <span>SALES {gstRate}%</span>
                                  <span>{Number(amount).toFixed(2)}</span>
                                </p>
                              )
                            )}
                          </td>
                          <td
                            className="invoice_table_product_data"
                            colSpan="2"
                            style={{ border: "1px solid black" }}
                          >
                            <p className="overall_report_bill">CGST</p>
                            {Object.entries(taxGroups).map(
                              ([gstRate, amount], idx) => (
                                <p className="overall_report_bill" key={idx}>
                                  <span>
                                    {state?.state
                                      ?.toLowerCase()
                                      .replace(/\s+/g, "") === "tamilnadu"
                                      ? `${(gstRate / 2).toFixed(2)}%`
                                      : "0.00"}
                                  </span>
                                  <span>
                                    {state?.state
                                      ?.toLowerCase()
                                      .replace(/\s+/g, "") === "tamilnadu"
                                      ? (amount / 2).toFixed(2)
                                      : "0.00"}
                                  </span>
                                </p>
                              )
                            )}
                          </td>

                          <td
                            className="invoice_table_product_data"
                            colSpan="2"
                            style={{ border: "1px solid black" }}
                          >
                            <p className="overall_report_bill">SGST</p>
                            {Object.entries(taxGroups).map(
                              ([gstRate, amount], idx) => (
                                <p className="overall_report_bill" key={idx}>
                                  <span>
                                    {state?.state
                                      ?.toLowerCase()
                                      .replace(/\s+/g, "") === "tamilnadu"
                                      ? `${(gstRate / 2).toFixed(2)}%`
                                      : "0.00"}
                                  </span>
                                  <span>
                                    {state?.state
                                      ?.toLowerCase()
                                      .replace(/\s+/g, "") === "tamilnadu"
                                      ? (amount / 2).toFixed(2)
                                      : "0.00"}
                                  </span>
                                </p>
                              )
                            )}
                          </td>

                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                        </tr>
                        {/* <tr>
                          <td className="invoice_table_product_data"></td>
                          <td
                            className="invoice_table_product_data"
                            style={{ border: "1px solid black" }}
                          >
                            <p className="overall_report_bill">
                              <span>TOTAL</span>
                              <span>0</span>
                            </p>
                          </td>
                          <td
                            className="invoice_table_product_data"
                            colSpan="2"
                            style={{ border: "1px solid black" }}
                          >
                            <p className="overall_report_bill">
                              <span>0.00</span>
                            </p>
                          </td>

                          <td
                            className="invoice_table_product_data"
                            colSpan="2"
                            style={{ border: "1px solid black" }}
                          >
                            <p className="overall_report_bill">
                              <span>0.00</span>
                            </p>
                          </td>

                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                          <td className="invoice_table_product_data"></td>
                        </tr> */}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            colSpan="2"
                            className="overall_footer_data"
                            style={{ border: "1px solid black" }}
                          >
                            TOTAL{" "}
                          </td>
                          <td
                            colSpan="12"
                            className="overall_footer_data"
                            style={{ border: "1px solid black" }}
                          >
                            Rs.
                            {data?.payments?.length == 0
                              ? Math.round(sumOfNetAmt).toLocaleString("en-IN")
                              : Math.round(
                                  Number(sumOfNetAmt || 0)
                                ).toLocaleString("en-IN")}
                          </td>
                        </tr>
                        <tr>
                          <td
                            className="invoice_table_product_data"
                            colSpan="6"
                          >
                            RUPEES &nbsp;
                            {/* {toWords(Number(sumOfNetAmt) || 0).toUpperCase()} */}
                            {toWords(
                              Math.round(Number(sumOfNetAmt) || 0)
                            ).toUpperCase()}
                            &nbsp; ONLY
                            <br />
                            <b>
                              Excutive :{" "}
                              {state?.executiveNameRoute?.execvutiveName || "-"}
                            </b>
                            <br />
                            <b>Vehicle No : {data?.vehiclenumber || "-"}</b>
                            <p className="text-end mt-4 mb-0">
                              Party Signature
                            </p>
                          </td>
                          <td
                            className="invoice_table_product_data"
                            colSpan="8"
                            style={{ border: "1px solid black" }}
                          >
                            Previous Balance : <b>{data?.balanceAmount || 0}</b>
                            <br />
                            <b>
                              Received Now. Rs.
                              {receivedbalance.toLocaleString("en-IN") || 0}
                            </b>
                            <br />
                            Current Balance Rs.{" "}
                            {pendingbalance.toLocaleString("en-IN") || 0}
                            <p className="text-end mt-4 mb-0">Signature</p>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </main>
                </div>
              </>
            );
          })}

        <div className="d-flex justify-content-center my-3 gap-3">
          <Controller
            name="selectFormat"
            control={control}
            defaultValue="a5"
            render={({ field }) => (
              <select {...field} className="invoice_download_btn">
                <option value="a4">A4 </option>
                <option value="a5">A5 </option>
              </select>
            )}
          />
          <button
            onClick={handleDownload}
            style={{ borderRadius: "6px" }}
            className="invoice_download_btn"
          >
            Download All
          </button>
        </div>
      </section>
    </>
  );
};

export default OverAllReportDownload;
